import { Injectable } from '@angular/core';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorService } from './error.service';
import { ApiError } from './api-error.model';
import { ErrorEnvelope } from './error-envelope.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errs: ErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        const apiErr = this.toApiError(e);
        this.errs.show(apiErr);       
        return throwError(() => e); 
      })
    );
  }

  private toApiError(e: HttpErrorResponse): ApiError {
    const now = new Date().toISOString();

    const env = e.error as ErrorEnvelope;
    if (this.isEnvelope(env)) {
      return {
        title: env.code || 'unexpected_error',
        message: env.message || 'Unexpected error.',
        code: env.code,
        correlationId: env.correlationId,
        traceId: env.traceId,
        status: e.status || undefined,
        url: e.url || undefined,
        time: now,
        details: this.pickSafe(env)
      };
    }
 
    const msg = e.status === 0
      ? 'Network error. Please check your connection.'
      : (e.message || 'Request failed.');

    return {
      title: 'http_error',
      message: msg,
      status: e.status || undefined,
      url: e.url || undefined,
      time: now
    };
  }

  private isEnvelope(x: any): x is ErrorEnvelope {
    return x && typeof x === 'object' && 'code' in x && 'message' in x && 'correlationId' in x;
  }

  private pickSafe(x: ErrorEnvelope): any {
    const keep: any = {};
    if (x.code) keep.code = x.code;
    if (x.message) keep.message = x.message;
    if (x.correlationId) keep.correlationId = x.correlationId;
    if (x.traceId) keep.traceId = x.traceId;
    return Object.keys(keep).length ? keep : undefined;
  }
}
